import type { InMemoryCache } from '@apollo/client';
import { useApolloClient, useQuery } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

import { useExperiment } from '@xing-com/hub';

import { LOGGED_IN_CARDS_PER_PAGE } from '../../config';
import { XcpFollowedCompaniesDocument } from '../../graphql/queries/followed-companies.gql-types';

const useFollowedCompanies = ({ first = LOGGED_IN_CARDS_PER_PAGE } = {}) => {
  const client = useApolloClient();
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  (client.cache as InMemoryCache).policies.addTypePolicies({
    Viewer: {
      fields: {
        followedCompanies: relayStylePagination(),
      },
    },
  });

  const { fetchMore, error, ...rest } = useQuery(XcpFollowedCompaniesDocument, {
    variables: {
      first,
      shouldHideKununuData: useExperiment('ABACUS-518') === 'B',
    },
    errorPolicy: 'all',
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const pagination = async (endCursor: string) => {
    await fetchMore({
      variables: {
        first,
        after: endCursor,
      },
    });
  };

  return {
    pagination,
    error,
    ...rest,
  };
};

export { useFollowedCompanies };
